import { render, staticRenderFns } from "./createEmail.vue?vue&type=template&id=1897cd81&"
import script from "./createEmail.vue?vue&type=script&lang=js&"
export * from "./createEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports